import { SxProps, Theme } from '@mui/system';

const styles = {

  root: {
    mb: '16px',
  },

  title: {
    fontSize: 20,
    fontWeight: 600,
    color: 'common.grey850',
  },

  updateButton: {
    marginRight: '8px',
    whiteSpace: 'nowrap',
  },

} satisfies Record<string, SxProps<Theme>>;

export default styles;
